<template>
  <div class="userForm">
    <AppForm
      cancenlMargin
      ref="form"
      formStyle="default"
      :fields="formFields"
      :rules="rules"
      :defaultValues="defaultValues"
      @cancel="cancel"
      @submit="submit"/>
  </div>
</template>

<script>
import { UserService } from '../../service/user.service';
import moment from 'moment';
	export default {
		name: 'formUserList',
		data() {
			return {
				defaultValues: {},
				userList:[],
				userPassword: '',
				rules: {
					head_pic: [{ required: true, message: '请选择头像'}],
					username: [{ required: true, message: '用户名不能为空'}],
					mobile: [{ required: true, message: '用户手机号不能为空'}],
					password: [{ required: true, message: '密码不能为空'}],
					real_name: [{ required: true, message: '联系人不能为空'}],
					tel_phone: [{ required: true, message: '联系电话不能为空'}],
				},
				formFields: [
					{ type: 'image', key: 'head_pic', pathType: 'user', label: '用户头像', span: 24, limit: 1 },
					{ type: 'input', key: 'nickname', label: '昵称', span: 12 },
					{ type: 'input', key: 'username', label: '用户名', span: 12 },
					{ type: 'password', key: 'password', label: '用户密码', span: 12 },
					{ type: 'input', key: 'mobile', label: '用户手机号', span: 12 },
					{ type: 'input', key: 'real_name', label: '联系人', span: 12 },
					{ type: 'input', key: 'tel_phone', label: '联系电话', span: 12 },
					{ type: 'input', key: 'email', label: '邮箱', span: 12 },
					{ type: 'input', key: 'qq', label: 'QQ号码', span: 12 },
					{ type: 'date', key: 'birthday', label: '生日', span: 12 },
					{ type: 'radio', key: 'sex', label: '性别', span: 12, options: [ { label: '男', value: 0 }, { label: '女', value: 1 }] },
					{ type: 'radio', key: 'status', label: '账号状态', span: 12, options: [ { label: '正常登录', value: 0 }, { label: '禁止登录', value: 1 }] }
				]
			}
		},
		created(){
			if(this.$route.query.type == 'edit'){
				const defaultValues = JSON.parse(JSON.stringify(this.$route.query.data));
				this.userPassword = defaultValues.password;
				defaultValues.birthday = defaultValues.birthday ? moment(defaultValues.birthday).toDate() : null;
				defaultValues.head_pic = [{
					uid: 1,
					name: '图片异常',
					status: 'done',
					url: defaultValues.head_pic
				}];
				this.defaultValues = defaultValues;
				if(this.defaultValues.is_distribution){
					this.formFields.splice(10,0,{ type: 'select_custom', key: 'level_name', label: '上级', options:[], span: 12 ,disabled:true})
				}
			}else{
				this.defaultValues = {};
			}
		},
		methods: {
			cancel() {
				this.$router.go(-1);
			},
			async submit(data) {
				if (this.userPassword === data.password && this.$route.query.type === 'edit') {
					data.password = '';
				}
				await UserService.save(data);
				this.$emit('success');
				this.cancel();
			}
		}
	}
</script>

<style lang="scss" scoped>

</style>